import {Component, inject, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Customer} from "../../../model/models";
import {CustomersService} from "../../../services/customers/customers.service";
import { NzTableModule } from "ng-zorro-antd/table";
import {YomaDateFormatPipe} from "../../../pipes/yoma-date-format.pipe";
import { NzTagModule } from 'ng-zorro-antd/tag';
import {UserStatsComponent} from "../user-stats/user-stats.component";

@Component({
  selector: 'customer-keyaccounts',
  standalone: true,
  imports: [NzTableModule, CommonModule, YomaDateFormatPipe, NzTagModule, UserStatsComponent],
  templateUrl: './customer-keyaccounts.component.html',
  styleUrl: './customer-keyaccounts.component.scss'
})
export class CustomerKeyaccountsComponent implements OnInit {
  @Input() customer!: Customer
  @Input() keyAccounts!: any

  customersService = inject(CustomersService)

  // keyAccounts: any = [];
  isLoading = false;

  ngOnInit(): void {
    // this.isLoading = true;
    // this.customersService.getKeyAccounts(this.customer.pk).subscribe({
    //   next: res => {
    //     this.keyAccounts = res;
    //     this.isLoading = false
    //   },
    //   error: err => {
    //     this.isLoading = false
    //   }
    // })
  }

}
